<template>
  <div>
    <el-form
      ref="requisitionForm"
      :model="requisition"
      label-width="80px"
      class="box"
    >
      <el-row v-if="requisition != null">
        <el-col :span="8">
          <el-form-item :label="$t('requisition.serialNo')">
            {{ requisition.serialNo }}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('text.workflowState')">{{
            $t("requisitionTypes." + requisition.workflowState)
          }}</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('requisition.dept')">{{
            requisition.dept
          }}</el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <fieldset class="mgb15">
      <legend>
        {{ $t("product.materialInfo") }}
        <el-button
          v-if="
            requisition &&
            requisition.finishAt == null &&
            Permit.canActionsChargeEdition('mmsRequisitionRaw')
          "
          type="primary"
          size="mini"
          @click="giveBatch('batch')"
          >{{ $t("action.give") }}</el-button
        >
        <el-button
          v-if="
            requisition &&
            requisition.finishAt == null &&
            Permit.canActionsChargeEdition('mmsRequisitionRaw')
          "
          type="success"
          size="mini"
          :loading="batchFinishDoing"
          @click="batchFinish"
          >{{ $t("action.finish") }}</el-button
        >
        <!-- v-if="requisition && requisition.finishAt == null" -->

        <el-button
          size="mini"
          type="default"
          @click="print('printDivSelect')"
          >{{ $t("action.print") }}</el-button
        >
      </legend>
      <vxe-table
        :loading="loadingMaterial"
        :data="groupMaterials"
        :span-method="mergeMethod"
        @checkbox-change="selectRecord"
        @checkbox-all="selectAllRecords"
        :checkbox-config="{ reserve: true }"
        id="bomsTable"
        row-id="id"
        ref="groupMaterialsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        highlight-hover-row
        auto-resize
        border
        :row-class-name="calculateBgColor"
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="checkbox"
          type="checkbox"
          width="35"
        ></vxe-table-column>
        <vxe-table-column
          field="materialSerialNo"
          :title="$t('material.serialNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <div v-if="row.isMerge">
              {{ row.subjectName }}
            </div>
            <span v-else>{{ row.materialSerialNo }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="materialName"
          :title="$t('material.name')"
          min-width="80"
        />
        <vxe-table-column
          field="color"
          :title="$t('material.color')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.color }}({{ row.colorNo }})
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('material.quantity')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.quantity }}{{ row.unit }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="givedQuantity"
          :title="$t('requisition.givedQuantity')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <el-popover placement="right" width="600" trigger="click">
              <vxe-table
                :data="row.requisitionMaterialRecords"
                size="mini"
                resizable
                round
                auto-resize
                highlight-hover-row
                :scroll-y="{ enabled: false }"
              >
                <vxe-table-column
                  field="quantity"
                  :title="$t('requisition.giveQuantity')"
                  min-width="80px"
                >
                  <template v-slot="{ row }">
                    <span v-if="row.stockType == 'out'">
                      {{ row.quantity }}
                      <small v-if="row.type == 'inventory'">(库存扣减)</small>
                      <small v-else>(余量扣减)</small>
                    </span>
                    <span v-if="row.stockType == 'in'" class="green">
                      {{ row.quantity }}<small>(入已发余量)</small>
                    </span>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="warehouseName"
                  :title="$t('requisition.giveWarehouseName')"
                  min-width="80px"
                />
                <vxe-table-column
                  field="createAt"
                  :title="$t('requisition.createAt')"
                  min-width="110px"
                />
                <vxe-table-column
                  field="ownerName"
                  :title="$t('requisition.ownerName')"
                  min-width="80px"
                />
                <vxe-table-column
                  field="remark"
                  :title="$t('text.remark')"
                  min-width="80"
                >
                  <template v-slot="{ row }">
                    <raw-html-limit-number :content="row.remark" :number="6" />
                  </template>
                </vxe-table-column>
              </vxe-table>
              <span
                slot="reference"
                class="popover-reference"
                v-if="row.givedQuantity != null"
              >
                {{ row.givedQuantity }}{{ row.unit }}
              </span>
            </el-popover>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="finishAt"
          :title="$t('requisition.finishAt')"
          min-width="80px"
        />
        <vxe-table-column
          field="inventories"
          :title="$t('inventory.quantity')"
          min-width="120px"
        >
          <template v-slot="{ row }">
            <span v-if="row.inventories != null">
              <div v-for="i of row.inventories" :key="i.id" class="font10">
                {{ i.warehouseName }}({{ i.shelf }})&nbsp; {{ i.storeQuantity
                }}{{ row.unit
                }}<span v-if="i.cashQuantity != 0"
                  >/{{ i.cashQuantity }}{{ row.unit }}</span
                >
              </div>
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="70"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number :content="row.remark" :number="5" />
          </template>
        </vxe-table-column>

        <vxe-table-column
          v-if="Permit.canActionsChargeEdition('mmsRequisitionRaw')"
          field="action"
          :title="$t('text.action')"
          width="120"
        >
          <template v-slot="{ row }">
            <span v-if="!row.isMerge">
              <el-button
                v-if="
                  row.finishAt == null &&
                  (Permit.currentUser().admin ||
                    Permit.mmsAuthSubjuctIds().includes(row.subjectId)) &&
                  ((Permit.currentTenant().config.mmsInvUseCash == true &&
                    row.givedQuantity < row.quantity) ||
                    Permit.currentTenant().config.mmsInvUseCash == false)
                "
                type="text"
                size="mini"
                @click="give(row)"
              >
                {{ $t("action.give") }}
              </el-button>
              <el-button
                v-if="
                  row.finishAt == null &&
                  (Permit.currentUser().admin ||
                    Permit.mmsAuthSubjuctIds().includes(row.subjectId))
                "
                type="text"
                size="mini"
                :loading="finishDoing"
                @click="finish(row)"
                >{{ $t("action.finish") }}</el-button
              >

              <el-button
                v-if="
                  row.finishAt == null &&
                  row.requisitionMaterialRecords &&
                  row.requisitionMaterialRecords.length === 0 &&
                  Permit.canActionsChargeEdition('mmsRequisitionRaw') &&
                  (Permit.currentUser().admin ||
                    Permit.mmsAuthSubjuctIds().includes(row.subjectId))
                "
                type="text"
                size="mini"
                @click="change(row)"
                >{{ $t("action.changeMaterial") }}</el-button
              >
            </span>
          </template>
        </vxe-table-column>
      </vxe-table>
    </fieldset>
    <fieldset class="mgb15" v-if="requisition && requisition.type === 'Order'">
      <legend>
        {{ $t("requisition.orderDetail") }}
      </legend>
      <div v-for="(order, index) of orders" :key="index" class="mgb15">
        <div class="mgb10">
          <span @click="setOrderExpendDF(index)">
            <i v-if="order.expendDF" class="el-icon-arrow-down" />
            <i v-if="!order.expendDF" class="el-icon-arrow-right" />
            {{ $t("order.serialNo") }}：{{ order.orderSerialNo }}
            <small>{{ $t("text.handOverAt2") }}:{{ order.handOverAt }}</small>
            <span class="mgl5">
              {{ $t("order.productInfo") }}：{{ order.productNo }}
              <span class="mgl5">{{ order.color }}</span>
              <span class="mgl5">{{ order.size }}</span
              ><span class="mgl5"
                >{{ $t("text.quantity") }}：{{ order.quantity
                }}{{ order.unit }}</span
              >
            </span>
          </span>
        </div>
        <div v-if="order.expendDF">
          <vxe-table
            :data="order.groupMaterials"
            :merge-cells="order.mergeCells"
            id="bomsTable"
            row-id="id"
            ref="groupOrderMaterialsTable"
            class="recordsTable"
            size="mini"
            resizable
            round
            highlight-hover-row
            auto-resize
            border
            :row-class-name="calculateBgColor"
            :scroll-y="{ enabled: false }"
          >
            <vxe-table-column
              field="materialSerialNo"
              :title="$t('material.serialNo')"
              min-width="100"
            >
              <template v-slot="{ row }">
                <div v-if="row.isMerge">
                  {{ row.subjectName }}
                </div>
                <span v-else>{{ row.materialSerialNo }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="materialName"
              :title="$t('material.name')"
              min-width="80"
            />
            <vxe-table-column
              field="color"
              :title="$t('material.color')"
              min-width="100"
            >
              <template v-slot="{ row }">
                {{ row.color }}({{ row.colorNo }})
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="quantity"
              :title="$t('material.quantity')"
              min-width="80"
            >
              <template v-slot="{ row }">
                {{ row.quantity }}{{ row.unit }}
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>
      </div>
    </fieldset>
    <fieldset
      class="mgb15"
      v-if="requisition && requisition.type === 'Purchase'"
    >
      <legend>
        {{ $t("requisition.purchaseDetail") }}
      </legend>
      <div v-for="(purchase, index) of purchases" :key="index" class="mgb15">
        <div class="mgb10">
          <span @click="setPurchaseExpendDF(index)">
            <i v-if="purchase.expendDF" class="el-icon-arrow-down" />
            <i v-if="!purchase.expendDF" class="el-icon-arrow-right" />
            {{ $t("purchase.serialNo") }}：{{ purchase.purchaseSerialNo }}
            <small
              >{{ $t("text.handOverAt2") }}:{{ purchase.handOverAt }}</small
            >
            <span class="mgl5">
              {{ $t("order.productInfo") }}：
              {{ purchase.productNo }}
              <span class="mgl5">{{ purchase.color }}</span>
              <span class="mgl5">{{ purchase.size }}</span>
              <span class="mgl5"
                >{{ $t("text.quantity") }}：{{ purchase.quantity
                }}{{ purchase.unit }}</span
              >
            </span>
          </span>
        </div>
        <div v-if="purchase.expendDF">
          <vxe-table
            :data="purchase.groupMaterials"
            :merge-cells="purchase.mergeCells"
            id="bomsTable"
            row-id="id"
            ref="groupOrderMaterialsTable"
            class="recordsTable"
            size="mini"
            resizable
            round
            highlight-hover-row
            auto-resize
            border
            :row-class-name="calculateBgColor"
            :scroll-y="{ enabled: false }"
          >
            <vxe-table-column
              field="materialSerialNo"
              :title="$t('material.serialNo')"
              min-width="100"
            >
              <template v-slot="{ row }">
                <div v-if="row.isMerge">
                  {{ row.subjectName }}
                </div>
                <span v-else>{{ row.materialSerialNo }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="materialName"
              :title="$t('material.name')"
              min-width="80"
            />
            <vxe-table-column
              field="color"
              :title="$t('material.color')"
              min-width="100"
            >
              <template v-slot="{ row }">
                {{ row.color }}({{ row.colorNo }})
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="quantity"
              :title="$t('material.quantity')"
              min-width="80"
            >
              <template v-slot="{ row }">
                {{ row.quantity }}{{ row.unit }}
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>
      </div>
    </fieldset>
    <div class="right pd20">
      <el-button size="small" type="default" @click="close">
        {{ $t("text.close") }}
      </el-button>
    </div>

    <!-- 发料 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('action.give')"
      :close-on-click-modal="false"
      :visible.sync="giveDF"
      width="30%"
    >
      <el-form ref="giveForm" :model="giveObj" label-width="80px">
        <el-form-item
          :prop="'warehouseId'"
          :label="$t('requisition.giveWarehouseName')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [
                $t('requisition.giveWarehouseName'),
              ]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            size="small"
            v-model.trim="giveObj.warehouseId"
            :disabled="!giveObj._selectWarehouseDF"
            clearabe
            filterable
            @change="selectWarehouse"
          >
            <el-option
              v-for="warehouse in mmsAuthWarehouses"
              :key="warehouse.id"
              :label="warehouse.name"
              :value="warehouse.id"
            />
          </el-select>
        </el-form-item>
        <span v-if="giveType == 'row'">
          <el-form-item
            :prop="'giveCashQuantity'"
            :label="$t('material.giveCashQuantity')"
            :rules="[
              {
                required: true,
                message: $t('rules.required', [$t('text.quantity')]),
                trigger: 'blur',
              },
            ]"
            v-if="Permit.currentTenant().config.mmsInvUseCash == true"
          >
            <el-input
              size="small"
              v-model.trim="giveObj.giveCashQuantity"
              :disabled="cashQuantityDisabledDF"
              @blur="giveCashQuantityBlur"
            >
              <template slot="append">{{ row.unit }}</template>
            </el-input>
          </el-form-item>
          <el-form-item
            :prop="'giveQuantity'"
            :label="$t('material.invDiffQuantity')"
            :rules="[
              {
                required: true,
                message: $t('rules.required', [$t('material.invDiffQuantity')]),
                trigger: 'blur',
              },
            ]"
          >
            <el-input size="small" v-model.trim="giveObj.giveQuantity">
              <template slot="append">{{ row.unit }}</template>
            </el-input>
          </el-form-item>
        </span>

        <el-form-item :prop="'remark'" :label="$t('text.remark')">
          <el-input
            size="small"
            v-model.trim="giveObj.remark"
            type="textarea"
          />
        </el-form-item>
        <div class="font10 orange">
          {{ $t("prompt.batchGiveMaterialExplain") }}
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="giveDoing"
          size="small"
          @click="giveSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="giveDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 换料 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('action.changeMaterial')"
      :close-on-click-modal="false"
      :visible.sync="changeDF"
      width="30%"
    >
      <el-form ref="changeForm" :model="changeObj" label-width="80px">
        <el-form-item
          :prop="'materialId'"
          :label="$t('requisition.changeMaterial')"
        >
          <el-select
            size="small"
            v-model="changeObj.materialId"
            filterable
            remote
            :remote-method="querySearchSerialNo"
            :loading="serialNosLoading"
            :clearable="true"
            :placeholder="$t('rules.mustFill', [$t('material.serialNoName')])"
            @change="handleSelectSerialNo"
          >
            <el-option
              v-for="material in materials"
              :key="material.id"
              :label="material.serialNoName"
              :value="material.id"
              :style="
                material.suppliersNoStr == '' ? '' : 'height: 55px !important'
              "
            >
              <div>
                <div>{{ material.serialNoName }}</div>
                <div class="suppliersNoStr">
                  {{ material.suppliersNoStr }}
                </div>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :prop="'quantity'"
          :label="$t('text.quantity')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.quantity')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="changeObj.quantity" />
        </el-form-item>
        <el-form-item :prop="'remark'" :label="$t('text.remark')">
          <el-input
            size="small"
            v-model.trim="changeObj.remark"
            type="textarea"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="changeDoing"
          size="small"
          @click="changeSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="changeDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 打印1Select -->
    <div id="printDivSelect" style="display: none">
      <div
        v-for="(groupMaterial, idx) in printGroupMaterials"
        :key="idx"
        :style="
          'margin:0 auto 10px; width:650px; text-align:left; font-size: 12px' +
          (idx == 0 ? '' : 'page-break-before: always;')
        "
      >
        <div
          style="
            width: 100%;
            text-align: center;
            font-size: 16px;
            margin-bottom: 20px;
          "
        >
          {{ groupMaterial.subjectName }}发料单
        </div>
        <div>
          <div>
            <div style="float: left; font-size: 14px">
              {{ $t("requisition.serialNo") }}：{{ requisition.serialNo }}
            </div>
            <div style="float: right; font-size: 14px">
              {{ $t("requisition.ownerName") }}：{{
                requisition.ownerName
              }}&nbsp; &nbsp;{{ $t("text.createAt") }}：{{
                requisition.createdAt
              }}
            </div>
          </div>
          <br />
          <div style="float: left; font-size: 14px">
            {{ $t("text.remark") }}：{{ requisition.remark }}
          </div>
          <br />
        </div>
        <div v-if="requisition.type === 'Order'">
          <table
            style="
              width: 70%;
              border-collapse: collapse;
              border: 1px solid black;
              font-size: 12px;
            "
          >
            <thead>
              <tr style="border: 1px solid black">
                <td style="border: 1px solid black">
                  {{ $t("order.serialNo") }}
                </td>
                <td style="border: 1px solid black">
                  {{ $t("product.productNo") }}
                </td>
                <td style="border: 1px solid black">
                  {{ $t("product.color") }}
                </td>
                <td style="border: 1px solid black">
                  {{ $t("product.size") }}
                </td>
                <td style="border: 1px solid black">
                  {{ $t("text.quantity") }}
                </td>
                <td style="border: 1px solid black">
                  {{ $t("text.handOverAt") }}
                </td>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(order, orderIndex) of orders"
                :key="orderIndex"
                style="border: 1px solid black"
              >
                <td style="border: 1px solid black">
                  {{ order.orderSerialNo }}
                </td>
                <td style="border: 1px solid black">{{ order.productNo }}</td>
                <td style="border: 1px solid black">{{ order.color }}</td>
                <td style="border: 1px solid black">{{ order.size }}</td>
                <td style="border: 1px solid black">{{ order.quantity }}</td>
                <td style="border: 1px solid black">{{ order.handOverAt }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="requisition.type === 'Purchase'">
          <table
            style="
              width: 70%;
              border-collapse: collapse;
              border: 1px solid black;
              font-size: 12px;
            "
          >
            <thead>
              <tr style="border: 1px solid black">
                <td style="border: 1px solid black">
                  {{ $t("purchase.serialNo") }}
                </td>
                <td style="border: 1px solid black">
                  {{ $t("product.productNo") }}
                </td>
                <td style="border: 1px solid black">
                  {{ $t("product.color") }}
                </td>
                <td style="border: 1px solid black">
                  {{ $t("product.size") }}
                </td>
                <td style="border: 1px solid black">
                  {{ $t("text.quantity") }}
                </td>
                <td style="border: 1px solid black">
                  {{ $t("text.handOverAt") }}
                </td>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(purchase, purchaseIndex) of purchases"
                :key="purchaseIndex"
                style="border: 1px solid black"
              >
                <td style="border: 1px solid black">
                  {{ purchase.purchaseSerialNo }}
                </td>
                <td style="border: 1px solid black">
                  {{ purchase.productNo }}
                </td>
                <td style="border: 1px solid black">{{ purchase.color }}</td>
                <td style="border: 1px solid black">{{ purchase.size }}</td>
                <td style="border: 1px solid black">{{ purchase.quantity }}</td>
                <td style="border: 1px solid black">
                  {{ purchase.handOverAt }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <table
            style="
              width: 100%;
              border-collapse: collapse;
              border: 1px solid black;
              font-size: 12px;
            "
          >
            <thead>
              <tr style="border: 1px solid black">
                <td style="border: 1px solid black; width: 100px">
                  {{ $t("material.serialNo") }}
                </td>
                <td style="border: 1px solid black; width: 60px">
                  {{ $t("material.name") }}
                </td>
                <td style="border: 1px solid black; width: 80px">
                  {{ $t("material.color") }}
                </td>
                <td style="border: 1px solid black; width: 60px">
                  {{ $t("material.quantity") }}
                </td>
                <td style="border: 1px solid black; width: 60px">
                  {{ $t("requisition.giveQuantity") }}
                </td>
                <td style="border: 1px solid black">
                  {{ $t("pendingRequisition.giveInfo") }}
                </td>
                <td style="border: 1px solid black; width: 60px">
                  {{ $t("requisition.finishAt") }}
                </td>
                <td style="border: 1px solid black; width: 120px">
                  {{ $t("text.remark") }}
                </td>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) of groupMaterial.materials"
                :key="index"
                style="border: 1px solid black"
              >
                <td style="border: 1px solid black">
                  {{ item.materialSerialNo }}
                </td>
                <td style="border: 1px solid black">{{ item.materialName }}</td>
                <td style="border: 1px solid black">
                  {{ item.color }}({{ item.colorNo }})
                </td>
                <td style="border: 1px solid black">
                  {{ item.quantity }}{{ item.unit }}
                </td>
                <td style="border: 1px solid black">{{ item.giveQuantity }}</td>
                <td style="border: 1px solid black">
                  <span v-if="item.requisitionMaterialRecords.length != 0">
                    <div
                      v-for="r of item.requisitionMaterialRecords"
                      :key="r.id"
                      class="font10"
                    >
                      {{ r.ownerName }}&nbsp;{{ r.warehouseName }}&nbsp;{{
                        r.quantity
                      }}{{ item.unit }}&nbsp;{{ item.remark }}
                    </div>
                  </span>
                </td>
                <td style="border: 1px solid black">{{ item.finishAt }}</td>
                <td style="border: 1px solid black">
                  <raw-html :content="item.remark" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <span style="margin-left: 20px; font-size: 14px">发料人：</span>
          <span style="margin-left: 150px; font-size: 14px">领料人：</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

import Vue from "vue";
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import RawHtml from "@/components/RawHtml";
import Requisition from "@/api/requisition.js";
import Warehouse from "@/api/warehouse.js";
import UserWarehouse from "@/api/userWarehouse.js";
import Material from "@/api/material.js";

export default {
  props: {
    id: Number,
  },
  mixins: [page],
  components: { RawHtml },
  data() {
    return {
      requisition: null,
      requisitionMaterials: [],
      groupMaterials: [],
      mergeCells: [],
      orders: [],
      purchases: [],
      loadingMaterial: false,
      //
      printGroupMaterials: [],
      //
      //
      warehouses: [],
      userWarehouses: [],
      mmsAuthWarehouses: [],
      //发料
      giveType: null,
      row: null,
      giveDF: false,
      giveObj: {
        requisitionMaterialId: null,
        giveQuantity: null,
        warehouseId: null,
        remark: null,
        _selectWarehouseDF: false,
        giveCashQuantity: null,
      },
      giveDoing: false,
      cashQuantityDisabledDF: false,
      //
      finishDoing: false,
      batchFinishDoing: false,
      // 换料
      materials: [],
      serialNosLoading: false,
      changeDF: false,
      changeObj: {
        materialId: null,
        quantity: null,
        remark: null,
      },
      changeDoing: false,
    };
  },
  watch: {
    id() {
      this.getRequisition();
      this.getRequisitionMaterials();
    },
  },
  created() {
    const self = this;
    this.getRequisition();
    this.getRequisitionMaterials();
  },

  methods: {
    // 打印发料单
    print(type) {
      const self = this;
      if (self.selectedMaterials().length === 0) {
        self.$message({
          message: self.$t("prompt.atLeastOneData"),
          type: "warning",
        });
        return;
      }
      this.printFunction(type);
      this.checkedItems = [];
      this.checkAllDF = false;
    },

    // h换料
    change(row) {
      const self = this;
      self.row = row;
      self.changeObj.remark = row.remark;
      self.changeObj.quantity = row.quantity;
      self.changeObj.materialId = null;
      self.changeDoing = false;
      self.changeDF = true;
    },
    querySearchSerialNo(queryString, cb) {
      const self = this;
      if (queryString == null || queryString.length < 1) {
        return;
      }
      this.serialNosLoading = true;
      Material.vagueFindBySerialNoOrName({ serialNo: queryString }).then(
        function (res) {
          self.materials = res.data;
          if (self.materials.length !== 0) {
            for (const material of self.materials) {
              Vue.set(
                material,
                "serialNoName",
                material.serialNo + "(" + material.name + ")"
              );
            }
          }
          self.serialNosLoading = false;
        }
      );
    },
    handleSelectSerialNo(item) {
      const self = this;
      if (
        self.requisitionMaterials.find((rm) => rm.materialId === item) != null
      ) {
        self.$message({
          message: self.$t("rules.exist", [self.$t("menu.materials")]),
          type: "warning",
        });
        self.changeObj.materialId = null;
      }
    },
    changeSubmit() {
      const self = this;
      self.$refs.changeForm.validate((valid) => {
        if (valid) {
          const appendRemark =
            "原" +
            self.row.materialSerialNo +
            "料调换成" +
            self.materials.find((m) => m.id === self.changeObj.materialId)
              .serialNo +
            "发料";
          if (self.changeObj.remark == null) {
            self.changeObj.remark = appendRemark;
          } else {
            self.changeObj.remark = self.changeObj.remark + "；" + appendRemark;
          }
          self.changeDoing = true;
          Requisition.change(
            self.requisition.id,
            self.row.id,
            self.changeObj
          ).then(function (res) {
            self.changeDoing = false;
            self.changeDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.changeSuccess"),
                type: "success",
              });
              self.getRequisitionMaterials();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 发料完成
    finish(row) {
      const self = this;
      self.finishDoing = true;
      Requisition.batchFinish([row.id]).then(function (res) {
        self.finishDoing = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.finishSuccess"),
            type: "success",
          });
          self.getRequisitionMaterials();
          self.$emit("updateData");
        } else {
          self.sysError();
        }
      });
    },
    batchFinish() {
      const self = this;
      if (self.selectedMaterials().length === 0) {
        self.$message({
          message: self.$t("prompt.atLeastOneData"),
          type: "warning",
        });
        return;
      }
      const canFinishMaterials = self
        .selectedMaterials()
        .filter((m) => m.finishAt == null);
      if (canFinishMaterials.length === 0) {
        self.$message({
          message: self.$t("prompt.atLeastOneValidData"),
          type: "warning",
        });
        return;
      }

      self.batchFinishDoing = true;
      Requisition.batchFinish(canFinishMaterials.map((m) => m.id)).then(
        function (res) {
          self.batchFinishDoing = false;
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.finishSuccess"),
              type: "success",
            });
            self.getRequisitionMaterials();
            self.$emit("updateData");
          } else {
            self.sysError();
          }
        }
      );
    },

    //发料
    giveBatch() {
      const self = this;
      if (self.selectedMaterials().length === 0) {
        self.$message({
          message: self.$t("prompt.atLeastOneData"),
          type: "warning",
        });
        return;
      }
      const canGiveMaterials = self
        .selectedMaterials()
        .filter(
          (m) =>
            m.requisitionMaterialRecords &&
            m.requisitionMaterialRecords.length == 0 &&
            m.finishAt == null
        );
      if (canGiveMaterials.length == 0) {
        self.$message({
          message: self.$t("prompt.hasGivedNotBatchGive"),
          type: "warning",
        });
        return;
      }
      self.giveObj.warehouseId = null;
      self.giveObj.remark = null;
      self.giveType = "batch";
      self.giveObj._selectWarehouseDF = true;
      self.getWarehouses();
      self.giveDF = true;
    },
    selectWarehouse() {
      const self = this;
      // console.log("===", self.giveObj.warehouseId, self.row.inventories);
      if (self.giveType == "row") {
        let obj = self.row.inventories.find(
          (i) => i.warehouseId == self.giveObj.warehouseId
        );
        if (obj == null || (obj != null && obj.cashQuantity == 0)) {
          self.cashQuantityDisabledDF = true;
          self.giveObj.giveCashQuantity = 0;
          self.giveObj.giveQuantity =
            Number(self.row.quantity) - Number(self.row.givedQuantity);
        } else {
          self.cashQuantityDisabledDF = false;
          let unGiveQty =
            Number(self.row.quantity) - Number(self.row.givedQuantity);
          self.giveObj.giveCashQuantity =
            unGiveQty > obj.cashQuantity ? obj.cashQuantity : unGiveQty;
          self.giveObj.giveQuantity =
            Number(self.row.quantity) -
            Number(self.row.givedQuantity) -
            Number(self.giveObj.giveCashQuantity);
        }
      }
    },
    giveCashQuantityBlur() {
      const self = this;
      if (self.giveObj.warehouseId == null) {
        self.$message({
          message: "先选择仓库",
          type: "success",
        });
        self.giveObj.giveCashQuantity = 0;
        return;
      }
      if (!Util.regexQuantity(self.giveObj.giveCashQuantity)) {
        self.$message({
          message: self.$t("rules.regex", [
            self.$t("material.giveCashQuantity"),
          ]),
          type: "warning",
        });
        self.giveObj.giveCashQuantity = 0;
        return;
      }
      let obj = self.row.inventories.find(
        (i) => i.warehouseId == self.giveObj.warehouseId
      );
      if (obj == null || (obj != null && obj.cashQuantity == 0)) {
        self.giveObj.giveCashQuantity = 0;
        self.cashQuantityDisabledDF = true;
      } else {
        self.cashQuantityDisabledDF = false;
        if (self.giveObj.giveCashQuantity > obj.cashQuantity) {
          self.$message({
            message: "库存扣减量超过库存余量的数量",
            type: "warning",
          });
          self.giveObj.giveCashQuantity = obj.cashQuantity;
        }
      }
    },
    give(row) {
      const self = this;
      self.row = row;
      self.getWarehouses();
      self.giveObj.requisitionMaterialId = row.id;
      self.giveObj.warehouseId = null;
      self.giveObj.remark = null;
      // self.giveObj.giveQuantity = row.quantity - row.givedQuantity;
      self.giveObj.giveQuantity = null;
      self.giveObj.giveCashQuantity = null;
      if (row.requisitionMaterialRecords.length !== 0) {
        self.giveObj.warehouseId =
          row.requisitionMaterialRecords[0].warehouseId;
        self.selectWarehouse();
      }
      self.giveObj._selectWarehouseDF =
        row.requisitionMaterialRecords.length == 0 ? true : false;
      self.giveType = "row";
      self.giveDoing = false;
      self.giveDF = true;
    },
    giveSubmit() {
      const self = this;
      self.$refs.giveForm.validate((valid) => {
        if (valid) {
          let obj = {
            remark: self.giveObj.remark,
            warehouseId: self.giveObj.warehouseId,
            giveDetails: [],
          };
          if (self.giveType == "row") {
            obj.giveDetails = [
              {
                requisitionMaterialId: self.giveObj.requisitionMaterialId,
                giveQuantity: self.giveObj.giveQuantity,
                giveCashQuantity: self.giveObj.giveCashQuantity,
              },
            ];
            // console.log("=====", obj);
            self.giveDoing = true;
            Requisition.manualGiveBatch(self.requisition.id, obj).then(
              function (res) {
                self.giveDoing = false;
                self.giveDF = false;
                if (res.status === 200) {
                  self.sysResults(res.data, self.$t("prompt.giveSuccess"));
                  self.getRequisitionMaterials();
                  self.$emit("updateData");
                } else {
                  self.sysError();
                }
              }
            );
          } else {
            const canGiveMaterials = self
              .selectedMaterials()
              .filter(
                (m) =>
                  m.requisitionMaterialRecords &&
                  m.requisitionMaterialRecords.length == 0 &&
                  m.finishAt == null
              );
            obj.giveDetails = canGiveMaterials.map((m) => {
              return {
                requisitionMaterialId: m.id,
                giveQuantity: null,
                giveCashQuantity: null,
              };
            });
            self.giveDoing = true;
            Requisition.autoGiveBatch(self.requisition.id, obj).then(function (
              res
            ) {
              self.giveDoing = false;
              self.giveDF = false;
              if (res.status === 200) {
                self.sysResults(res.data, self.$t("prompt.giveSuccess"));
                self.getRequisitionMaterials();
                self.$emit("updateData");
              } else {
                self.sysError();
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    //
    getWarehouses() {
      const self = this;
      axios
        .all([
          Warehouse.findByTenantId(),
          UserWarehouse.findByUserId(self.Permit.currentUser().id),
        ])
        .then(
          axios.spread(function (warehouses, userWarehouses) {
            self.warehouses = warehouses.data;
            self.userWarehouses = userWarehouses.data;
            if (self.Permit.currentUser().admin) {
              self.mmsAuthWarehouses = self.warehouses;
            } else {
              const userWarehouseIds = self.userWarehouses.map(
                (u) => u.warehouseId
              );
              self.mmsAuthWarehouses = self.warehouses.filter((w) =>
                userWarehouseIds.includes(w.id)
              );
            }
          })
        );
    },
    //====
    getRequisition() {
      const self = this;
      self.loadingStart();
      Requisition.findById(self.id).then(function (res) {
        if (res.data.code === 200) {
          self.requisition = res.data.entity;
          if (self.requisition.type == "Order") {
            self.getOrders();
          }
          if (self.requisition.type == "Purchase") {
            self.getPurchases();
          }
        } else {
          self.sysError();
        }
        self.loadingEnd();
      });
    },
    getRequisitionMaterials() {
      const self = this;
      self.loadingMaterial = true;
      Requisition.materials(self.id).then(function (res) {
        if (res.status === 200) {
          self.requisitionMaterials = res.data;
          self.groupMaterials = self.buildTableData(self.requisitionMaterials);
          self.mergeCells = self.buildMergeCells(self.requisitionMaterials);
          self.loadingMaterial = false;
        } else {
          self.sysError();
        }
      });
    },
    //
    getOrders() {
      const self = this;
      Requisition.orders(self.requisition.id).then(function (res) {
        if (res.status === 200) {
          self.orders = res.data;
          if (self.orders.length !== 0) {
            for (const order of self.orders) {
              const groupMaterials = self.buildTableDataOrder(
                order.orderMaterials
              );
              Vue.set(order, "expendDF", false);
              Vue.set(order, "groupMaterials", groupMaterials);
              Vue.set(
                order,
                "mergeCells",
                self.mergeCellsOrder(groupMaterials)
              );
            }
          }
        } else {
          self.sysError();
        }
      });
    },
    setOrderExpendDF(index) {
      this.orders[index].expendDF = !this.orders[index].expendDF;
    },
    buildTableDataOrder(materals) {
      const self = this;
      if (materals.length === 0) {
        return;
      }
      const subjectIds = materals.map((b) => b.subjectId);
      const subjectIdsSet = [...new Set(subjectIds)];
      let groupMaterials = [];
      for (const subjectId of subjectIdsSet) {
        const currentSubjectMaterials = materals.filter(
          (b) => b.subjectId == subjectId
        );
        groupMaterials.push({
          isMerge: true,
          subjectId: subjectId,
          subjectName: currentSubjectMaterials[0].subjectName,
          materials: currentSubjectMaterials,
        });
        for (const material of currentSubjectMaterials) {
          groupMaterials.push(material);
        }
      }
      return groupMaterials;
    },
    mergeCellsOrder(groupMaterials) {
      let mcs = [];
      for (let i = 0, rowIdx = 0; i < groupMaterials.length; i++) {
        if (groupMaterials[i].isMerge) {
          mcs.push({ row: rowIdx, col: 0, rowspan: 1, colspan: 4 });
        }
        if (groupMaterials[i].materials) {
          rowIdx = rowIdx + groupMaterials[i].materials.length + 1;
        }
      }
      return mcs;
    },
    //
    getPurchases() {
      const self = this;
      Requisition.purchases(self.requisition.id).then(function (res) {
        if (res.status === 200) {
          self.purchases = res.data;
          if (self.purchases.length !== 0) {
            for (const purchase of self.purchases) {
              const groupMaterials = self.buildTableDataPurchase(
                purchase.purchaseMaterials
              );
              Vue.set(purchase, "expendDF", false);
              Vue.set(purchase, "groupMaterials", groupMaterials);
              Vue.set(
                purchase,
                "mergeCells",
                self.mergeCellsPurchase(groupMaterials)
              );
            }
          }
        } else {
          self.sysError();
        }
      });
    },
    setPurchaseExpendDF(index) {
      this.purchases[index].expendDF = !this.purchases[index].expendDF;
    },
    buildTableDataPurchase(materals) {
      const self = this;
      if (materals.length === 0) {
        return;
      }
      const subjectIds = materals.map((b) => b.subjectId);
      const subjectIdsSet = [...new Set(subjectIds)];
      let groupMaterials = [];
      for (const subjectId of subjectIdsSet) {
        const currentSubjectMaterials = materals.filter(
          (b) => b.subjectId == subjectId
        );
        groupMaterials.push({
          isMerge: true,
          subjectId: subjectId,
          subjectName: currentSubjectMaterials[0].subjectName,
          materials: currentSubjectMaterials,
        });
        for (const material of currentSubjectMaterials) {
          groupMaterials.push(material);
        }
      }
      return groupMaterials;
    },
    mergeCellsPurchase(groupMaterials) {
      let mcs = [];
      for (let i = 0, rowIdx = 0; i < groupMaterials.length; i++) {
        if (groupMaterials[i].isMerge) {
          mcs.push({ row: rowIdx, col: 0, rowspan: 1, colspan: 4 });
        }
        if (groupMaterials[i].materials) {
          rowIdx = rowIdx + groupMaterials[i].materials.length + 1;
        }
      }
      return mcs;
    },
    // 物料构造
    buildTableData(records) {
      let rs = [];
      if (records.length === 0) {
        return [];
      }
      records.forEach((record) => {
        let bOrder = {
          isMerge: true,
          subjectId: record.id,
          subjectName: record.name,
          materials: record.requisitionMaterials,
        };
        rs.push(bOrder); //将bargain的数据转换到格式，放到数据列表
        record.requisitionMaterials.forEach((material) => {
          rs.push(material);
        });
      });
      return rs;
    },
    buildMergeCells(records) {
      let mcs = [];
      if (records.length == 0) {
        return [];
      }
      for (let i = 0, rowIdx = 0; i < records.length; i++) {
        if (this.Permit.canActionsChargeEdition("mmsRequisitionRaw")) {
          mcs.push({ row: rowIdx, col: 1, rowspan: 1, colspan: 9 });
        } else {
          mcs.push({ row: rowIdx, col: 1, rowspan: 1, colspan: 8 });
        }
        if (records[i].requisitionMaterials) {
          rowIdx = rowIdx + records[i].requisitionMaterials.length + 1;
        }
      }
      return mcs;
    },
    mergeMethod({ rowIndex, columnIndex }) {
      const mergeCells = this.buildMergeCells(this.requisitionMaterials);
      for (let mIndex = 0; mIndex < mergeCells.length; mIndex++) {
        const { row, col, rowspan, colspan } = mergeCells[mIndex];
        if (row === rowIndex && col === columnIndex) {
          return { rowspan, colspan };
        }
        if (
          rowIndex >= row &&
          rowIndex < row + rowspan &&
          columnIndex >= col &&
          columnIndex < col + colspan
        ) {
          return { rowspan: 0, colspan: 0 };
        }
      }
      return { rowspan: 1, colspan: 1 };
    },
    calculateBgColor({ row, rowIndex }) {
      return row.isMerge ? "light-blue-bg" : "";
    },
    selectedSubjects() {
      return this.$refs.groupMaterialsTable
        .getCheckboxRecords()
        .filter((r) => r.isMerge);
    },
    selectedMaterials() {
      return this.$refs.groupMaterialsTable
        .getCheckboxRecords()
        .filter((r) => !r.isMerge);
    },
    selectRecord({ rowIndex, selection, checked, row, data }) {
      if (row.isMerge) {
        let materials = data.filter((r) => r.subjectId == row.subjectId);
        this.$refs.groupMaterialsTable.setCheckboxRow(materials, checked);
      }
      this.printGroupSelectedMaterials();
      this.setSelectedQty();
    },
    selectAllRecords() {
      this.printGroupSelectedMaterials();
      this.setSelectedQty();
    },
    setSelectedQty() {
      this.selectRecordQty =
        this.$refs.groupMaterialsTable &&
        this.$refs.groupMaterialsTable.getCheckboxRecords().length;
    },
    // 打印发料单
    printGroupSelectedMaterials() {
      const self = this;
      if (self.selectedMaterials() && self.selectedMaterials().length == 0) {
        return [];
      }
      self.printGroupMaterials = [];
      const subjectIds = self.selectedMaterials().map((b) => b.subjectId);
      const subjectIdsSet = [...new Set(subjectIds)];
      for (const subjectId of subjectIdsSet) {
        const currentSubjectMaterials = self
          .selectedMaterials()
          .filter((b) => b.subjectId == subjectId);
        self.printGroupMaterials.push({
          subjectId: subjectId,
          subjectName: currentSubjectMaterials[0].subjectName,
          materials: currentSubjectMaterials,
        });
      }
    },

    close() {
      this.$emit("close");
    },
  },
};
</script>
